export function normalizeListFromApi(response) {
  if (!response) {
    return [];
  }

  if (response.status != null && response.status !== 200) {
    return [];
  }

  const body = response.data ?? response;

  if (Array.isArray(body)) {
    return body;
  }

  if (Array.isArray(body?.data)) {
    return body.data;
  }

  return [];
}
